// extracted by mini-css-extract-plugin
var _1 = "IntegrationsPanelHeader-moduleIntegrationsPanelHeader__VE2Ej";
var _2 = "IntegrationsPanelHeader-moduleheadline__MZOqP";
var _3 = "IntegrationsPanelHeader-modulelogo__EIAGv";
var _4 = "IntegrationsPanelHeader-moduletitle__rEg5Z";
export { _1 as "IntegrationsPanelHeader", _2 as "headline", _3 as "logo", _4 as "title" }
